module.exports = __webpack_public_path__ + "img/csm_logo.714c7959.png";